import React, { Component } from "react";

class DefaultFooter extends Component {

    render() {
        const isFooterVisible = this.props.config.configDetails.displayFooter === true;
        return (
            <div className="s360-default-footer" style={this.footerStyle()} onClick={() => { if (isFooterVisible) window.open(this.props.config.configDetails.footerLink); }}>
                   <div className="s360-default-footer-text"  style={{visibility: isFooterVisible ? "visible" : "hidden"}} >{this.props.config.configDetails.footerText}</div>
                   {/* <div className="s360-default-footer-image-container"> */}
                       {this.props.config.configDetails.footerIcon && <img src={this.props.config.configDetails.footerIcon} style={{maxWidth: this.props.config.designDetails.iconWidth, height: "20px", objectFit:"contin", alignSelf: "center", paddingLeft:"5px", visibility: isFooterVisible ? "visible" : "hidden", display: isFooterVisible ? "block" : "none",paddingTop:'10px' }} alt="" />}
                    <div className="s360-default-footer-text s360-default-footer-text-suffix"  style={{visibility: isFooterVisible ? "visible" : "hidden"}} >{this.props.config.configDetails.footerBrandText || ""}</div>
                    {/* </div> */}
                   {/* src="https://dev.simplify360.com/whitelabel/2/images/sf360_colored_logo.png" */}
            </div>
            )
    }

    footerStyle = () => {
        return {
            color:          this.props.config.designDetails.footerFontColor,
            fontFamily:     this.props.config.designDetails.footerFont,
            fontSize:       this.props.config.designDetails.footerFontSize+"px",
            width:          "100%",
            height:         "30px",
            position:       "absolute",
            bottom: "0px",
            paddingBottom:"2px",
            backgroundColor: "white",
            cursor: "pointer"
        }
    }

}

export default DefaultFooter;